/*jshint esversion: 6 */
/*jshint strict:false */

const getDefaultState = () => {
    return {
        valuationLogId: null,
        serviceData: {
            VehicleConditionFromCustomer: '',
            ServiceHistory: '',
            ServiceHistoryType: '',
            LastServiceDate: '',
            LastServiceType: '',
            NumberOfServices: 0,
        },
        mechanicalCondition: {
            V5CPresent: '',
            ServiceVehicle: '',
            DamageOrFaults: '',
            KeepRegistration: '',
            SpareOrInflationKitPresent: '',
            ChargingCablePresent: '',
            LockingWheelNutPresent: '',
            NumberWornTyres: '',

            FunctioningMediaScreen: '',
            FunctioningDoorHandles: '',
            FunctioningCentralLocking: '',
            WarningLightsDisplaying: '',
            OilLeakOrUnusualEngineNoise: '',
            TimingKitReplaced: '',
            ItemsInBootPresent: '',
            NumberOfWorkingKeys: '',

        },
        vehicleHealthCheck: {
            OffsideFrontTyreAdvised: { display: false, value: false },
            NearsideFrontTyreAdvised: { display: false, value: false },
            OffsideRearTyreAdvised: { display: false, value: false },
            NearsideRearTyreAdvised: { display: false, value: false },
            FrontBrakePadsAdvised: { display: false, value: false },
            RearBrakePadsAdvised: { display: false, value: false },
            FrontBrakePadsAndDiscsAdvised: { display: false, value: false },
            RearBrakePadsAndDiscsAdvised: { display: false, value: false },
            WarningLights: { display: false, value: false },
            WiperSystem: { display: false, value: false },
            ExhaustSystem: { display: false, value: false },
            SuspensionSystem: { display: false, value: false },
            ExteriorLights: { display: false, value: false },
        },

        vehicleImagery: {
            phone: null,
            TchekUrl: null,
            requestUrl: null,
            messageSentCount: 0,
            messageSentState: false
        },

        tchekImages: {
            damaged: null,
            inspectedImages: null,
            completed: false
        },

        extendedValuationCompleted: false
    };
};

const state = getDefaultState();

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setServiceDataState(state, serviceData) {
        state.serviceData.ServiceHistory = serviceData;
        if (serviceData === 'Not Due' || serviceData === 'None') {
            state.serviceData.ServiceHistoryType = '';
            state.serviceData.LastServiceDate = '';
            state.serviceData.LastServiceType = '';
            state.serviceData.NumberOfServices = 0;
        }
    },
    setServiceDataType(state, serviceData) {
        state.serviceData.ServiceHistoryType = serviceData;
    },
    setServiceDataLastServiceDate(state, serviceData) {
        state.serviceData.LastServiceDate = serviceData;
    },
    setServiceDataLastServiceType(state, serviceData) {
        state.serviceData.LastServiceType = serviceData;
    },
    setServiceDataCount(state, serviceData) {
        state.serviceData.NumberOfServices = serviceData;
    },
    // setServiceDataExpiryDate(state, serviceData){
    //     state.serviceData.expiryDate = serviceData;
    // },
    setCondition(state, condition) {
        state.serviceData.VehicleConditionFromCustomer = condition;
    },
    setWorkingKeyCount(state, keyCount) {
        state.mechanicalCondition.NumberOfWorkingKeys = keyCount;
    },
    setNumberWornTyres(state, value) {
        state.mechanicalCondition.NumberWornTyres = value;
    },
    setLockingWheelNutPresent(state, value) {
        state.mechanicalCondition.LockingWheelNutPresent = value;
    },
    setChargingCablePresent(state, value) {
        state.mechanicalCondition.ChargingCablePresent = value;
    },
    setFunctioningMediaScreen(state, value) {
        state.mechanicalCondition.FunctioningMediaScreen = value;
    },
    setTimingKitReplaced(state, value) {
        state.mechanicalCondition.TimingKitReplaced = value;
    },
    setMobileNumber(state, number) {
        state.vehicleImagery.phone = number;
    },
    setMessageSentState(state, messageSent) {
        state.vehicleImagery.messageSentState = messageSent;
    },
    increaseMessageSentCount(state) {
        state.vehicleImagery.messageSentCount++;
    },
    setTchekUrl(state, url) {
        state.vehicleImagery.TchekUrl = url;
    },
    setRequestUrl(state, url) {
        state.vehicleImagery.requestUrl = url;
    },
    setValuationLogId(state, valuationLogId) {
        state.valuationLogId = valuationLogId;
    },
    updateMechanicalCondition(state, { optionName, value }) {
        state.mechanicalCondition[optionName] = value;
    },
    updateVehicleHealthCheckData(state, { optionName, value }) {
        state.vehicleHealthCheck[optionName].value = value;
    },
    setTchekImages(state, data) {
        state.tchekImages.damaged = data.damaged;
        state.tchekImages.inspectedImages = data.inspectedImages;
        state.tchekImages.completed = true;
    },
    updateVehicleHealthCheckBulk(state, data) {
        Object.keys(data).forEach(key => {
            if (Object.hasOwn(state.vehicleHealthCheck, key)) {
                state.vehicleHealthCheck[key].value = data[key];
            }
        });
    },
    updateDisplayVehicleHealthCheckQuestions(state, data) {
        // If tyres are not advised from health check add to general questions
        if (data.OffsideFrontTyreAdvised === false) {
            state.mechanicalCondition.FrontBrakesPadsWorn = '';
        }
        if (data.OffsideRearTyreAdvised === false) {
            state.mechanicalCondition.RearBrakesPadsWorn = '';
        }
        Object.keys(data).forEach(key => {
            if (Object.hasOwn(state.vehicleHealthCheck, key)) {
                state.vehicleHealthCheck[key].display = data[key];
            }
        });
    },
    setExtendedValuationData(state, vehicleData) {
        state.valuationLogId = state.valuationLogId;
        state.extendedValuationCompleted = vehicleData.completed;
        if (vehicleData.service_data !== null) {
            Object.keys(state.serviceData).forEach(key => {
                state.serviceData[key] = vehicleData.service_data[key] ?? '';
            });
        }
        if (vehicleData?.mechanical_condition != null) {
            Object.keys(vehicleData.mechanical_condition).forEach(key => {
                if (state.vehicleHealthCheck[key]) {
                    const condition = vehicleData.mechanical_condition[key];
                    state.vehicleHealthCheck[key].value = condition.value;
                    state.vehicleHealthCheck[key].display = condition.display;
                } else if (key in state.mechanicalCondition) {
                    state.mechanicalCondition[key] = vehicleData.mechanical_condition[key] ?? '';
                }
            });
        }
        if (vehicleData?.tchek_inspector_reference != null) {
            state.vehicleImagery.phone = vehicleData.phone;
            state.vehicleImagery.TchekUrl = vehicleData.tchek_inspector_reference.TchekUrl;
            state.vehicleImagery.RequestUrl = vehicleData.tchek_inspector_reference.RequestUrl;
        }
        if (vehicleData?.tchek_images != null) {
            state.tchekImages.damaged = vehicleData.tchek_images.damaged;
            state.tchekImages.inspectedImages = vehicleData.tchek_images.inspectedImages;
            state.tchekImages.completed = true;
        }
    },
};

const actions = {
    setData({ commit, dispatch }, { data }) {
        // Commit valuation data to ValuationTool module
        commit('ValuationTool/setValuationData', data, { root: true });
        if (!state.valuationLogId && data) {
            commit('setValuationLogId', data.id);
        }
        // Commit extended valuation data if present
        if (data.extended_valuation !== null) {
            commit('setExtendedValuationData', data.extended_valuation);
            commit('ValuationTool/setStep', data.extended_valuation?.first_incomplete_step, { root: true });
        } else {
            commit('ValuationTool/setStep', 4, { root: true });
        }
        // setUser data
        if (data.valuation_lead && data.valuation_lead.request) {
            let customerDetails = JSON.parse(data.valuation_lead.request);
            let locationId = data.valuation_lead.location_id;
            if (locationId) {
                customerDetails['location-id'] = locationId;
            }
            // customer data used for booking valuation
            commit('ValuationTool/setCustomerData', customerDetails, { root: true });
            // set customer data used for sign up
            commit('CustomerData/setCustomerData', customerDetails, { root: true });
        }
        // Set dealer information
        if (data.valuation_lead?.location_id) {
            dispatch('ValuationTool/useSpecificDealer', data.valuation_lead.location_id, { root: true })
        }
        commit('ValuationTool/setLoadingValuationData', false, { root: true });
    },

    async fetchValuation({ commit, dispatch, state }) {
        const queryParams = new URLSearchParams(window.location.search);
        const urlValuationId = queryParams.get('valuation');
        const tchekSecret = queryParams.get('tchek');
        let valuationId = urlValuationId && !isNaN(urlValuationId) ? parseInt(urlValuationId, 10) : null;
        // set valuationID if not passed this is used when login in to continue a valuation
        if (valuationId === null) {
            valuationId = state.valuationLogId;
        }
        try {
            commit('ValuationTool/setLoadingValuationData', true, { root: true });
            dispatch('Auth/checkAuthenticated', null, { root: true });

            let url = valuationId
                ? `/valuation/get-valuation/${valuationId}`
                : '/valuation/get-valuation';
            // use secret to go to redirect after tchek imaging is completed
            if (tchekSecret) {
                url += `/${tchekSecret}`;
            }
            const response = await axios.get(url);
            if (response && response.data) {
                if (response.data.message === 'No existing valuation found, ready to start a new valuation.') {
                    console.info(response.data.message);
                } else {
                    dispatch('setData', { data: response.data });
                }
            }
        } catch (error) {
            console.error("Error fetching valuation:", error);
            if (valuationId && this.hasModule('Auth')) {
                commit('setValuationLogId', valuationId);
                commit('Auth/setShowLoginModal', {
                    show: true,
                    type: '',
                }, { root: true });
                commit('Auth/setLoginOnly', true, { root: true });
            }
        } finally {
            commit('ValuationTool/setLoadingValuationData', false, { root: true });
        }
    },

    async registerAndSave({ commit, dispatch }) {
        try {
            if (this.hasModule('Auth')) {
                commit('Auth/setShowLoginModal', {
                    show: true,
                    type: '',
                }, { root: true });
            }
        } catch (error) {
            console.error("Error saving valuation:", error);
        }
    },

    async saveAndContinue({ commit, dispatch }) {
        try {
            await dispatch('storeValuation');
            commit('ValuationTool/incrementStep', null, { root: true });
        } catch (error) {
            console.error("Error saving valuation:", error);
        }
    },

    async storeValuation({ commit, state, dispatch, rootState }, { storeOnly = false } = {}) {
        if (state.valuationLogId === null) {
            const valuationLogId = rootState.ValuationTool.valuationLogId;
            commit('setValuationLogId', valuationLogId)
        }
        const step = rootState.ValuationTool.step;
        const data = {
            registration: rootState.ValuationTool.registration,
            current_step: step,
            valuation_log_id: state.valuationLogId,
            image: rootState.ValuationTool.selectedVehicle.image_url,
            store_only: storeOnly
        };
        console.log('data', data, step);
        switch (step) {
            case 6:
                data.service_data = state.serviceData;
                data.mileage = rootState.ValuationTool.mileage
                break;
            case 7:
                data.service_data = state.serviceData;
                break;
            case 8:
                const mechanicalCondition = state.mechanicalCondition;
                Object.entries(state.vehicleHealthCheck).forEach(([key, obj]) => {
                    mechanicalCondition[key] = obj;
                });
                data.mechanical_condition = mechanicalCondition;
                data.request_url = window.location.href;
                break;
            case 9:
                data.completed = true
                break;
        }
        try {
            const response = await axios.post("/valuation/save-valuation", data);
            if (step === 6) {
                commit('setServiceDataState', response.data.valuation_response.ServiceHistory);
                if (response.data.valuation_response.numberServices > 0) {
                    commit('setServiceDataLastServiceDate', response.data.valuation_response.lastServiceDate)
                    commit('setServiceDataLastServiceType', 'Full')
                    commit('setServiceDataCount', response.data.valuation_response.numberServices)
                }
                dispatch('setDisplayVehicleHealthCheckQuestions', response.data.valuation_response);
            }
            if (step === 7) {
                const hasWornOrDamagedParts = Object.values(response.data.valuation_response).some(value => value === true);
                if (hasWornOrDamagedParts) {
                    dispatch('setDisplayVehicleHealthCheckQuestions', response.data.valuation_response);
                    dispatch('setBulkExtraWornOrDamagedPartsData', response.data.valuation_response);
                }
            }
            if (step === 8) {
                commit('setTchekUrl', response.data.valuation_response.TchekUrl)
                commit('setRequestUrl', response.data.valuation_response.RequestUrl)
            }
            if (response.data.valuation_log && response.data.valuation_log.valuation_amounts !== undefined && response.data.valuation_log.valuation_amounts !== null) {
                commit('ValuationTool/setValuation', response.data.valuation_log.valuation_amounts, { root: true })
            }
        } catch (error) {
            console.error("Error saving valuation:", error);
            throw error;
        }
    },

    setBulkExtraWornOrDamagedPartsData({ commit }, data) {
        commit('updateVehicleHealthCheckBulk', data);
    },
    setDisplayVehicleHealthCheckQuestions({ commit }, data) {
        commit('updateDisplayVehicleHealthCheckQuestions', data);
    },

    setVehicleHealthCheckCondition({ commit }, { optionName, value }) {
        commit('updateVehicleHealthCheckData', { optionName, value });
    },

    setMechanicalCondition({ commit }, { optionName, value }) {
        commit('updateMechanicalCondition', { optionName, value });
    },

    sendTchekImagerySms({ commit, state }, formData) {
        let telephone = Object.fromEntries(formData).telephone;
        commit('setMobileNumber', telephone)
        commit('increaseMessageSentCount')

        return axios.post(`/valuation/send-tchek-sms/${state.valuationLogId}`, {
            number: telephone,
        })
            .then(response => {
                commit('setMessageSentState', true);
                setTimeout(() => {
                    commit('setMessageSentState', false);
                }, 60000);
                return response;
            })
            .catch(error => {
                commit('setMessageSentState', false);
                if (error.response && error.response.data) {
                    return Promise.reject(error.response.data);
                }

                return Promise.reject({ errors: { general: ['An unexpected error occurred.'] } });
            });
    },

    async clearSession({ dispatch }, keys) {
        try {
            await axios.post(`/valuation/clear-session`, {
                session_keys: keys
            });
            dispatch('resetStore');
        } catch (error) {
            console.error(error);
        }
    },

    async openTchekUrl({ dispatch }, data) {
        try {
            await axios.post(`/valuation/open-tchek-url`, {
                page_url: data,
                tchek_url: data
            });
        } catch (error) {
            console.error(error);
        }
    },

    goToBookAppointment({ commit, rootState }) {
        commit('ValuationTool/setDisplayBookAppointment', true, { root: true });
        const currentStep = rootState.ValuationTool.step;
        if (currentStep !== 4) {
            commit('ValuationTool/setStep', 10, { root: true });
        }
    },

    async getTchekImages({ commit, state }) {
        try {
            const response = await axios.get(`/valuation/getImages/${state.valuationLogId}`);
            if (response && response.data) {
                commit('setTchekImages', response.data);
                commit('ValuationTool/setDisplayBookAppointment', true, { root: true });
            }
        } catch (error) {
            console.error(error);
        }
    },

    resetStore({ commit }) {
        commit('resetState');
    },
};

const getters = {
    getVehicleHealthCheckOptions: (state) => (optionName) => {
        return state.vehicleHealthCheck[optionName].value;
    },
    getOption: (state) => (optionName) => {
        return state.mechanicalCondition[optionName];
    },
    tchekImages: state => state.tchekImages
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./resources/assets/js/valuation-tool/store/modules/valuation-extended.js